/**
 * @Time    : 2024/8/29 15:29
 * @Author  : tlovet
 * @Software: WebStorm
 * 操作localStorage的方法集
 */

import { DEFAULT_ENUM } from '@/utils/enum';

/** 通用方法-供本文件内其他方法使用 */
// 从localStorage获取指定key的值
const getLocalStorage = (
  key: string = 'WEB',
  defaultValue: any = '',
  valueType: 'str' | 'object' = 'str',
) => {
  if (valueType === 'str') {
    return localStorage.getItem(key) || defaultValue;
  }
  try {
    const jsonString = localStorage.getItem(key);
    if (jsonString) {
      return JSON.parse(jsonString) || defaultValue;
    }
    return jsonString || defaultValue;
  } catch (err) {
    return defaultValue;
  }
};
// 把信息写入localStorage
const setLocalStorage = (
  key: string = 'WEB',
  value: any = '',
  valueType: 'str' | 'object' = 'str',
) => {
  if (typeof value === 'object' || valueType === 'object') {
    localStorage.setItem(key, JSON.stringify(value));
  } else {
    localStorage.setItem(key, value);
  }
};

/** 主题相关 */
// 从localStorage里面获取Theme
export const getTheme = (defaultValue: NavThemeType = DEFAULT_ENUM.DEFAULT_THEME): NavThemeType => {
  return getLocalStorage('THEME', defaultValue);
};
// 把Theme写入localStorage
export const setTheme = (value: NavThemeType = DEFAULT_ENUM.DEFAULT_THEME) => {
  return setLocalStorage('THEME', value);
};

/** 全局搜索相关 */
type GlobalSearchHistoryType = { appkey: string; to: { pathname: string; search: string } }[];
// 从localStorage里面获取GlobalSearchHistory
export const getGlobalSearchHistory = (
  defaultValue: GlobalSearchHistoryType = [],
): GlobalSearchHistoryType => {
  return getLocalStorage('GLOBAL_SEARCH_HISTORY', defaultValue, 'object');
};
// 把GlobalSearchHistory写入localStorage
export const setGlobalSearchHistory = (value: GlobalSearchHistoryType = []) => {
  return setLocalStorage('GLOBAL_SEARCH_HISTORY', value, 'object');
};
